/**
 * Layout maths shared by the board and the mat. Pure, so the numbers that
 * decide whether something fits can be tested without a DOM.
 */

/**
 * Spacing for a row of `count` things: the natural `max` pitch while they fit
 * inside `span`, then tighter, so a crowded row packs closer together instead
 * of spilling out of whatever contains it.
 */
export function packPitch(count: number, span: number, max: number): number {
  return count > 1 ? Math.min(max, span / (count - 1)) : max;
}

/** Trim a coordinate for an SVG path string. */
export const r2 = (n: number): number => Math.round(n * 100) / 100;
